import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ArComponent } from './ar/ar.component';
import { AdminComponent } from './admin/admin.component';
import { DashComponent } from './dash/dash.component';
import { AutoreportComponent } from './autoreport/autoreport.component';
import { ReportcenterComponent } from './reportcenter/reportcenter.component';
import { ZendeskComponent } from './Zendesk/Zendesk.component';
import { TwilioVideoRxqComponent } from './twilio-video-rxq/twilio-video-rxq.component';

import {AuthGuard} from "./guards/auth.guard";
import {RoleGuardService as RoleGuard} from './guards/role-guard-service.guard';


const routes: Routes = [
    {
        path: 'login/:id/:page',
        component: LoginComponent
    },
    {
        path: 'ar',
        component: ArComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'dash',
        component: DashComponent,
        canActivate: [AuthGuard]
  },
  {
    path: 'reportcenter',
    component: ReportcenterComponent,
    canActivate: [AuthGuard]
  },
    //{
    //    path: 'PageNotFound',
    //    component: PageNotFoundComponent
    //},
  {
    path: 'autoreport/:id',
    component: AutoreportComponent,
  },
  {
    path: 'autoreport/:id/:emailToken',
    component: AutoreportComponent,
  },
  {
    path: 'zendesk',
    component: ZendeskComponent,
  },
  {
    path: 'TwilioVideoRxq',
    component: TwilioVideoRxqComponent,
  },
  {
    path: 'TwilioVideoRxq/:CamearaName',
    component: TwilioVideoRxqComponent,
  },
  {
    path: 'TwilioVideoRxq/:CamearaName/:AccessToken/:RoomId',
    component: TwilioVideoRxqComponent,
  },
    {
        path: '**',
        component: LoginComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts